import { createEntityExtension } from "../mystekz-linked-entities";
import { ProductsManager } from "./manager";
import { LinkedEntity } from "../mystekz-linked-entities";
import { type ProductInTree } from "@/stores/products-store";
import { h } from "vue";
import { vnodeToHtml } from "@/utils";
import GenericCard from "@/components/EntityInfo/GenericCard.vue";
import { EntityType } from "@/stores/entity-store";

export type ProductEntity = LinkedEntity<"product", ProductInTree>;

let productsManager: ProductsManager;
/**
 * Get the business entity manager for a given domain.
 */
export const getProductesManager = (baseUrl: string) => {
    if (!productsManager) {
        productsManager = new ProductsManager(baseUrl);
    }
    return productsManager;
};

export const ProductsExtension = createEntityExtension(
    "product",
    import.meta.env.VITE_BASE_URL,
    true,
    {
        popup: {
            key: "productDetails",
            hover: true,
            create: (_: Promise<ProductEntity | void>, entityId: string) => {
                return () => {
                    return vnodeToHtml(
                        h(GenericCard, {
                            entityId,
                            entityType: EntityType.PRODUCT,
                        })
                    );
                };
            },
        },
        prefix: "",
    },
    {
        popup: {
            key: "productInsert",
        },
    },
    getProductesManager,
    {
        label: "Products",
        showInInlineMenu: true,
        caret: true,
        icon: {
            name: "pi-box",
            library: "primeicons",
        },
        group: "Linked Entities",
    }
);
